<script lang="ts">
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Design system components
	import { Button, Input, Text, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	let settings = readDeviceSettings(id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore ?? settings;

	let value = settings.longpush_duration_ms;
	let min = value.min;
	let max = value.max;

	let cache = { ...value };
	let local_ip = get_local_ip(id);
	let loading = false;

	const set_longpush_time = async () => {
		if (cache.min !== value.min || cache.max !== value.max) {
			let res;
			loading = true;
			value.min = min;
			value.max = max;

			if (local_ip) {
				res = await localReq(device, `${local_ip}/settings/`, 'post', {
					longpush_duration_ms_min: min,
					longpush_duration_ms_max: max,
				});
			} else {
				res = await postReq(`/device/inputs_reader/longpush_duration`, {
					min: value.hasOwnProperty('min') ? value.min : undefined,
					max: value.max,
					id: id,
				});
			}

			if (res.isok) {
				settings.longpush_duration_ms = value;
				// toast.open('success',`Long push time was changed to ${value.min?'min ' +value.min+' ':''} - max ${value.max} ms.`);
				toast.open({
					type: 'success',
					title: $format('longpush_ms_scc_toast') || 'Longpush time set to successfully.',
				});
				devices_settings.update_devices_settings(id, settings);
				cache = { ...value };
			} else {
				toast.open({ type: 'danger', title: $format('longpush_ms_err_toast') });
				value = { ...cache };
			}
			loading = false;
		}
	};
</script>

<Text styleType="body-small" class="mb-s">{$format('longpush_ms_description')}</Text>

{#if value.hasOwnProperty('min')}
	<Text styleType="body-small" class="mb-s">{$format('min')} (100 - 3000ms)</Text>
	<Input
		icon="null"
		size="m"
		class="mb-s"
		bind:value={min}
		type={'number'}
		min={100}
		max={3000}
		on:enter={set_longpush_time}
		id="input-1leqs6i"
		aria-label={$format('min', { default: 'Min' })}
	/>
{/if}
<Text styleType="body-small" class="mb-s">
	{$format('max')} ({!device.type.includes('BTN') ? 200 : 800} - {!device.type.includes('BTN')
		? 6000
		: 2000}ms)
</Text>
<Input
	icon="fas fa-clock"
	class="mb-s"
	size="m"
	bind:value={max}
	type={'number'}
	min={!device.type.includes('BTN') ? 200 : 800}
	max={!device.type.includes('BTN') ? 6000 : 2000}
	on:enter={set_longpush_time}
	id="input-3psyzx9"
	aria-label={$format('max', { default: 'Max' })}
/>
<Button class="mt-s" {loading} size="m" width="full" on:click={set_longpush_time}
	>{$format('button_save')}</Button
>
